import { useCallback, useMemo } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { generateUrlWithCompany } from 'src/helpers/helpers';
import { isHomePath } from 'src/helpers/errorRecovery';

export const useErrorRecovery = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const isHome = isHomePath(location.pathname);
  const companyId = useMemo(() => {
    const companyFromUrl = new URLSearchParams(location.search).get('companyId');
    return companyFromUrl || localStorage.getItem('bhiCurrentCompany') || undefined;
  }, [location.search]);

  const recover = useCallback(() => {
    navigate(generateUrlWithCompany('/home', companyId), { replace: true });
  }, [companyId, navigate]);

  return {
    recover,
    recoveryActionLabel: 'Return to home',
    showRecoveryAction: !isHome,
    recoveryKey: location.key,
  };
};
